import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBTabPane,
  MDBTabContent,
  MDBNav,
  MDBNavItem,
  MDBNavLink,
  MDBBadge,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
} from "mdbreact";

import "../css/scrollbar.css";
import useWindowDimensions from "../components/useWindowDimensions.js";

import AccessDenied from "../components/AccessDenied";

import PriceCheckerTable from "./PriceCheckerTable";

const PriceChecker = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };

  const [showPreloader, setPreloader] = useState("normal");
  const { width } = useWindowDimensions();

  const [rows, setRows] = useState([]);

  const [selRow, setSelectedRow] = useState("");

  const [modalAddEdit, showAddEdit] = useState(false);

  const toggleAddEdit = () => {
    showAddEdit(!modalAddEdit);
    loadData();
  };

  const [bRefresh, setRefresh] = useState(false);
  function refreshGrid() {
    setRefresh(!bRefresh);
    loadData();
  }

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function loadData() {
    Axios.get(props.apiServer + "/Itemslist", bearer)
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function loadDeleteItems() {
    Axios.get(props.apiServer + "/deleteditemslist", bearer)
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const [activeTab, setActiveTab] = useState("1");
  const toggleClassicTabs3 = (x) => {
    if (x === "1") {
      loadData();
    } else if (x === "2") {
      loadDeleteItems();
    } else {
      loadData();
    }
    setActiveTab(x);
  };

  const useMountEffect = (functionName) => useEffect(functionName, []);

  useMountEffect(loadData);

  const TabItems = (x) => {
    return (
      <React.Fragment>
        <MDBNav
          classicTabs
          className="mt-5 cloudy-knoxville-gradient brown-text small"
        >
          {x.isSmall === true ? (
            <React.Fragment>
              <MDBNavItem>
                <MDBNavLink
                  link
                  to="#"
                  active={activeTab === "1"}
                  onClick={() => toggleClassicTabs3("1")}
                  className="brown-text pl-2 pr-2"
                >
                  <MDBIcon fas icon="barcode" className="brown-text" />
                </MDBNavLink>
              </MDBNavItem>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <MDBNavItem>
                <MDBNavLink
                  to="#"
                  active={activeTab === "1"}
                  onClick={() => toggleClassicTabs3("1")}
                  className="brown-text"
                >
                  <MDBIcon
                    fas
                    icon="barcode"
                    size="2x"
                    className="brown-text"
                  />
                  <br />
                  <br />
                  <b>Active Items</b>
                </MDBNavLink>
              </MDBNavItem>
            </React.Fragment>
          )}
        </MDBNav>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <div className="classic-tabs">
        {width <= 767 ? (
          <>
            <TabItems isSmall={true} />
          </>
        ) : (
          <>
            <TabItems isSmall={false} />
          </>
        )}

        <MDBTabContent
          className="card mb-5 pt-0 pl-0 pr-0 pb-0"
          activeItem={activeTab}
        >
          <MDBTabPane tabId="1">
            {showPreloader === "normal" ? (
              <MDBRow>
                <MDBCol md="4"></MDBCol>
                <MDBCol md="4" className="text-center">
                  <br />
                  <img
                    src={props.deployURL + "/loading.gif"}
                    style={{ width: "300px", textAlign: "center" }}
                    alt="loading"
                  />
                  <br />
                </MDBCol>
                <MDBCol md="4"></MDBCol>
              </MDBRow>
            ) : (
              <PriceCheckerTable
                rows={rows}
                loadData={loadData}
                apiServer={props.apiServer}
                apiServerHybrid={props.apiServerHybrid}
                title="Active Items"
                toggleModal={toggleAddEdit}
                refreshGrid={refreshGrid}
                description="List of Active Items"
              />
            )}
          </MDBTabPane>
        </MDBTabContent>
      </div>

      {/*    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    /> */}
    </React.Fragment>
  );
};

export default PriceChecker;
